import React, { useState } from 'react';
import Modal from '../../../components/ui/Modal';
import Button from '../../../components/ui/Button';
import Icon from '../../../components/AppIcon';

const StarRating = ({ value, onChange, label, size = 24 }) => {
    return (
        <div className="flex flex-col gap-1.5">
            <label className="text-sm font-normal text-slate-700">{label}</label>
            <div className="flex items-center gap-1">
                {[1, 2, 3, 4, 5].map((star) => (
                    <button
                        key={star}
                        type="button"
                        onClick={() => onChange(star)}
                        className="transition-transform hover:scale-110 focus:outline-none"
                    >
                        <Icon
                            name="Star"
                            size={size}
                            className={`${star <= value
                                    ? 'text-yellow-400 fill-yellow-400'
                                    : 'text-muted-foreground/30'
                                }`}
                        />
                    </button>
                ))}
                <span className="ml-2 text-sm text-muted-foreground font-medium">
                    {value > 0 ? `${value}/5` : ''}
                </span>
            </div>
        </div>
    );
};

const FeedbackModal = ({ isOpen, onClose, onSubmit, isSubmitting }) => {
    const [ratingStars, setRatingStars] = useState(0);
    const [aiQuality, setAiQuality] = useState(0);
    const [realism, setRealism] = useState(0);
    const [voiceTone, setVoiceTone] = useState(0);
    const [comment, setComment] = useState('');

    const handleSubmit = () => {
        onSubmit({
            rating_stars: ratingStars || 5, // Default to 5 if skipped/missed but submitted
            ai_quality_rating: aiQuality || 5,
            realism_rating: realism || 5,
            voice_tone_rating: voiceTone || 5,
            comment
        });
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={() => { }} // Force user to choose submit or skip
            title="How was your interview?"
            titleClassName="text-base font-medium text-slate-900"
            size="lg"
        >
            <div className="space-y-6">
                <p className="text-slate-900 text-sm">
                    Your feedback helps us improve the AI interviewer quality.
                </p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <StarRating
                        label="Overall Experience"
                        value={ratingStars}
                        onChange={setRatingStars}
                        size={32}
                    />
                    <StarRating
                        label="AI Response Quality"
                        value={aiQuality}
                        onChange={setAiQuality}
                    />
                    <StarRating
                        label="Realism of Interaction"
                        value={realism}
                        onChange={setRealism}
                    />
                    <StarRating
                        label="Voice & Tone"
                        value={voiceTone}
                        onChange={setVoiceTone}
                    />
                </div>

                <div className="space-y-2">
                    <label className="text-sm font-normal text-slate-700">
                        Additional Comments (Optional)
                    </label>
                    <textarea
                        value={comment}
                        onChange={(e) => setComment(e.target.value)}
                        placeholder="Tell us what you liked or what could be improved..."
                        className="w-full h-24 px-3 py-2 bg-background border border-border rounded-lg focus:outline-none focus:ring-2 focus:ring-emerald-500/30 focus:border-emerald-500 transition-colors resize-none text-sm"
                    />
                </div>

                <div className="flex items-center justify-end gap-3 pt-4 border-t border-border">
                    <Button
                        variant="ghost"
                        onClick={onClose}
                        disabled={isSubmitting}
                        className="hover:bg-slate-100 hover:text-slate-900 text-slate-500"
                    >
                        Skip Feedback
                    </Button>
                    <Button
                        variant="default"
                        onClick={handleSubmit}
                        loading={isSubmitting}
                        disabled={ratingStars === 0}
                        iconName="Send"
                        iconPosition="left"
                    >
                        Submit Feedback
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default FeedbackModal;
